var map = {
	"./en": 68079,
	"./en.js": 68079,
	"./en.json": 71549,
	"./id": 36260,
	"./id.js": 36260,
	"./id.json": 59637,
	"./ja": 55794,
	"./ja.js": 55794,
	"./ja.json": 87220,
	"./ko": 39697,
	"./ko.js": 39697,
	"./ko.json": 38933,
	"./kok": 36299,
	"./kok.js": 36299,
	"./kok.json": 75306,
	"./th": 51210,
	"./th.js": 51210,
	"./th.json": 9999,
	"./zh": 39176,
	"./zh.js": 39176,
	"./zh.json": 4984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24141;